<template>
<div>
    <el-button-group>
        <div class="height-20"></div>
      </el-button-group>
      <!-- 表格组件 -->
    <TableList
        componentTableId="PbSchoolManagement"
        @update-list="updateList"
        excelName="日志管理"
        :table-data="tableData"
        :header-data="headerData"
        :table-height="tableMaxHeight"
        :loading="loading"
        :loading-text="loadingText"
        :empty-text="emptyText"
        @searchFnc="searchFnc"
        @handleSelection="handleSelection"
        class="mt-20"
    >
    <template #messageCustom="scope">
        <span class="gray" v-if="scope.scope.message == 'null' || !scope.scope.message">未设置</span>     
        <el-button v-else type="primary" size="mini" @click="detailHandle(scope.scope.message)">查看详情</el-button>
    </template>
    </TableList>
    <!-- 底部工具 -->
    <Pagination
        :pagination="pagination"
        :is-loading="loading"
        @change-pagination="changePagination"
    >
    </Pagination>
    <el-dialog title="内容详情" v-model="dialogTableVisible" v-if="dialogTableVisible" :visible.sync="dialogTableVisible">
        <div class="message">{{message}}</div>
    </el-dialog>
</div>
</template>
<script>
    import TableList from "@/components/TableHeaderCom/index.vue";
    import {GetLogs} from 'network/login.js';
    import { isNull, timeFormatNew,isDateLessThanYesterday,compareDates } from "../../common/utils";
    import Pagination from "@/components/Pagination.vue";
    export default{
        components:{
            TableList,
            Pagination
        },
        name:"SystemLog",
        props: {
            tableMaxHeight: Number,
        },
        data(){
            return{
                dialogTableVisible:false,
                emptyText: "暂无数据",
                headerData: [                
                    {
                    label: "内容详情",
                    prop: "message",
                    width: "160",
                    align: "center",
                    noSetText: "未设置",
                    custom: true,
                    noTooltip:false
                    },
                    {
                    label: "状态码",
                    prop: "statusCode",
                    width: "140",
                    align: "center",
                    type: "InputSearch",
                    },
                    {
                    label: "日志级别",
                    prop: "level",
                    align: "center",
                    width: "180",
                    selectOptions: [
                        { key: "Critical", value: "严重" },
                        { key: "Debug", value: "调试" },
                        { key: "Error", value: "错误" },
                        { key: "Information", value: "常规信息" },
                        { key: "None", value: "不写入" },
                        { key: "Trace", value: "追踪" },
                        { key: "Warning", value: "警告" }
                    ],
                    type: "SelectSearch",
                    },
                    {
                    label: "消息内容",
                    prop: "message",
                    width: "260",
                    align: "center",
                    noSetText: "未设置",
                    noTooltip: true,
                    type: "InputSearch",
                    noTooltip:false
                    },
                    {
                    label: "请求方式",
                    prop: "method",
                    width: "180",
                    align: "center",
                    noSetText: "未设置",
                    noTooltip: true,
                    },
                    {
                    label: "客户端ip",
                    prop: "clientIp",
                    width: "180",
                    align: "center",
                    noSetText: "未设置",
                    noTooltip: false,
                    type: "InputSearch",
                    },
                    {
                    label: "参数",
                    prop: "queryString",
                    width: "180",
                    align: "center",
                    noSetText: "未设置",
                    noTooltip: false,
                    },
                    {
                    label: "请求地址",
                    prop: "requestPath",
                    width: "260",
                    align: "center",
                    type: "InputSearch",
                    },
                    {
                    label: "主机地址",
                    prop: "host",
                    width: "300",
                    align: "center",
                    noSetText: "未设置",
                    noTooltip: true,
                    },
                    {
                    label: "查询时间",
                    prop: "logTime",
                    width: "180",
                    align: "center",
                    noSetText: "未设置",
                    noTooltip: true,
                    fixed: "right",
                    type: "DateSelect",
                    valueFormat:'YYYY-MM-DD HH:mm:ss',
                    dateAndTime: true,
                    dateType: "datetime",
                    lastTimeStart: '',
                    lastTimeTimeEnd: '',
                    }
                ],
                tableLoading: false,
                loadingText: "loading...", //加载状态提示文本
                tableData: [],
                pagination: {
                    currentPage: 1,
                    pageSize: 20,
                    total: 0
                },
                requestData: {
                    // logstore: null,
                    // statusCode: 0,
                    // method: null,
                    // message: null,
                    // requestPath: null,
                    // logLevel: null,
                    startTime: timeFormatNew(
                    this.getLastMonth(new Date()),
                    "yyyy-MM-dd hh:mm:ss"
                    ),
                    endTime: timeFormatNew(new Date(), "yyyy-MM-dd hh:mm:ss"),
                    pageIndex: 1,
                    pageSize: 20
                },
                levelList: [
                    { key: "Critical", value: "严重" },
                    { key: "Debug", value: "调试" },
                    { key: "Error", value: "错误" },
                    { key: "Information", value: "常规信息" },
                    { key: "None", value: "不写入" },
                    { key: "Trace", value: "追踪" },
                    { key: "Warning", value: "警告" }
                ],
                logStoreList: [],
                searchData: null,
                dialogVisible: false,
                msgList: "",
                ismaxImize:false
            }
        },
        created() {
            this.getData();
            this.headerData.map(item => {
            if (item.prop == "level") {
                item.selectOptions = this.levelList;
            }
            });
        },
        methods:{
            // 获取当前时间的前一个月
            getLastMonth(date) {
                const now = new Date(date);
                const year = now.getFullYear();
                const month = now.getMonth() + 1;
                const day = now.getDate();
                const nowMonthDay = new Date(year, month, 0).getDate(); // 当前月的总天数
                if (month - 1 <= 0) return year - 1 + "-" + 12 + "-" + day; // 如果是1月，年数往前推一年
                const lastMonthDay = new Date(year, parseInt(month) - 1, 0).getDate();
                if (lastMonthDay >= day) return year + "-" + (month - 1) + "-" + day;
                if (day < nowMonthDay)
                    return (
                    year + "-" + (month - 1) + "-" + (lastMonthDay - (nowMonthDay - day))
                    ); // 1个月前所在月的总天数小于现在的天日期
                return year + "-" + (month - 1) + "-" + lastMonthDay; // 当前天日期小于当前月总天数
            },
            // 分页
            changePagination(val) {
                console.log(val)
                this.pagination.currentPage=val.currentPage;
                this.pagination.pageSize = val.pageSize;
                this.updateList();
            },
            detailHandle(msg) {
                this.dialogTableVisible = true;
                this.message = msg;
            },
            // 更新列表
            updateList() {
                this.getData();
            },
            // 搜索
            searchFnc(val) {
                this.searchData = val;
                if (!isNull(val.prop) && val.prop == "statusCode") {
                    this.requestData.statusCode = Number(val.value) ? Number(val.value) : 0;
                }
                if (!isNull(val.prop) && val.prop == "level") {
                    this.requestData.logLevel = val.value;
                }
                if (!isNull(val.prop) && val.prop == "message") {
                    this.requestData.message = val.value;
                }
                if (!isNull(val.prop) && val.prop == "requestPath") {
                    this.requestData.requestPath = val.value;
                }
                if (!isNull(val.prop) && val.prop == "clientIp") {
                    this.requestData.clientIp = val.value;
                }
                if (!isNull(val.prop) && val.prop == "logTime") {
                    if (val.name == "dateAndTime") {
                    // 跟踪截止时间
                    this.requestData.endTime = isNull(val.value.end)
                        ? null
                        : val.value.end;
                    // 跟踪起始时间
                    this.requestData.startTime = isNull(val.value.start)
                        ? null
                        : val.value.start;
                        if(this.requestData.endTime){
                            let str=this.requestData.endTime.slice(0,10)
                            str=str.split('-')
                            // 当结束时间小于昨天，需要选择开始时间
                            if(isDateLessThanYesterday(str[0]*1,str[1]*1,str[2]*1)){
                                if(!this.requestData.startTime){
                                    this.$alert('请选择开始时间');
                                    return
                                }
                            }                           
                        }
                    }
                    if(this.requestData.endTime&&this.requestData.startTime){
                        if(compareDates(this.requestData.startTime,this.requestData.endTime)){
                            this.$alert('开始时间不能大于结束时间');
                            return
                        }
                        if(this.requestData.endTime==this.requestData.startTime){
                            this.$alert('开始时间不能等于结束时间');
                            return
                        }
                    }

                }
                this.requestData.pageIndex = 1;
                this.pagination.currentPage = 1;
                this.getData();
            },
            async getData() {
                this.emptyText = "加载中";
                if (this.tableLoading) {
                    return false;
                }
                this.tableLoading = true;
                this.loadingText = "loading...";
                this.requestData.pageIndex = this.pagination.currentPage;
                this.requestData.pageSize = this.pagination.pageSize;
                const res = await GetLogs(this.requestData);
                if (res.code == 1) {
                    this.emptyText = this.tableData ? "" : "暂无数据";
                    this.tableData = res.result.data;
                    // 格式化日志级别
                    this.tableData.map(item => {
                    this.levelList.map(l => {
                        if (item.level == l.key) {
                        item.level = l.value;
                        }
                    });
                    });
                    this.pagination.total = res.result.totalRecords;
                    this.tableLoading = false;
                } else {
                    this.tableLoading = false;
                    this.$alert(res.message);
                }
            },
        }
    }
</script>
<style scoped>
.height-20{
    height: 42px;
}
.message{
    word-wrap: break-word;
    font-size: 16px;
    line-height: 25px;
    max-height: 500px;
    overflow-y: scroll;
}
</style>